import type { FileCategory } from '@brighterly/lib-core-types/files/interfaces'

import { WsEvent } from '@ts-ws/enums'

import { useDisciplineStore } from '@stores/discipline'

import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

interface FilesEventProps {
  files_total: number
  files_new: number
  categories: FileCategory[]
}

export const useListenEventFiles = (channel: any): void => {
  const disciplineStore = useDisciplineStore()
  onDisciplineReady(() => {
    channel.listen(WsEvent.FilesUpdated, async (props: FilesEventProps): Promise<void> => {
      disciplineStore.setDisciplineNewFiles(props.files_new)
    })
  })
}
